import { FC, ReactNode } from "react";

export const MarketCardsFallback: FC = () => (
  <ul className="mobile-cards">
    {[...Array(4)].map((_, i) => (
      <li key={`market-card-skeleton-${i}`} className="mobile-card market-card">
        <div className="flex ai-c gap-1">
          <div className="icon-denom skeleton br-2" />
          <div className="skeleton h-2 w-8 br-2" />
          <div
            className="skeleton round ml-a"
            style={{ height: 60, width: 60 }}
          />
        </div>
        <div className="skeleton h-4 w-full br-2" />
        <div className="skeleton h-5 w-full br-2" />
        <div className="skeleton h-3 w-full br-2" />
      </li>
    ))}
  </ul>
);

export const MarketCards: FC<{ children: ReactNode }> = ({ children }) => (
  <ul className="mobile-cards">{children}</ul>
);
